module.exports = __webpack_public_path__ + "static/img/bg_bosch.2f1a414.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/urzadzenia/bg_bosch.svg
// module id = LMXp
// module chunks = 1